import { clearEmailOptin } from './consultActions';
import { setTermsAndPrivacyAccepted } from '../../utils/variables';

export function clearInputsAskQs() {
    document.querySelectorAll('.askQuestion__container .valid').forEach((i) => {
        i.classList.remove('valid');
    });
    document
        .querySelectorAll('.askQuestion__container .invalid')
        .forEach((i) => {
            i.classList.remove('invalid');
        });

    document.querySelectorAll('.askQuestion__container input').forEach((i) => {
        i.value = '';
    });

    document
        .querySelectorAll('.askQuestion__container textarea')
        .forEach((i) => {
            i.value = '';
        });

    clearEmailOptin();

    setTermsAndPrivacyAccepted(false);
    document
        .querySelectorAll('.askQuestion__container .terms-privacy-checkbox')
        .forEach((el) => el.classList.remove('is-checked'));

    const container = document.querySelector('.askQuestion__container');
    if (container) container.classList.remove('step-2');
}
